import React from "react";

export default function Versao1011() {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-black mt-8">
        Histórico – Versão 1.0.11
      </h2>

      <ul className="space-y-4 text-black text-base leading-relaxed">
        <li>
          <strong>⚡ Mais performance:</strong>
          <p className="ml-4">
            Otimizações no carregamento e na navegação para uma experiência mais rápida.
          </p>
        </li>

        <li>
          <strong>📅 Data e Hora nos chamados:</strong>
          <p className="ml-4">
            Correção da listagem de data e hora na tabela de chamados. Agora é possível ajustar a data e hora manualmente.
          </p>
        </li>

        <li>
          <strong>📝 Campo de Tipo de Serviço inteligente:</strong>
          <p className="ml-4">
            O campo "Tipo de Serviço" agora aceita digitação e filtra automaticamente as opções disponíveis.
          </p>
        </li>
      </ul>
    </div>
  );
}